module.exports = __webpack_public_path__ + "static/media/Social Desirability - jon-tyson-tangfe8KQdw-unsplash.1be9686b.jpg";